import '../globals';
import {Collapse} from "bootstrap";

;(function ($) {
    'use strict';

    var pluginName = 'formScripts';

    function Plugin(element) {
        this.element = $(element);
        this._name = pluginName;
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        /**
         * Init
         */
        init: function () {
            this.toggleCollapseCheckbox()
        },

        /**
         * Toggle Collapse Checkbox
         */
        toggleCollapseCheckbox: function () {
            var collapseElement = this.element.find('[data-toggle="collapse"],[data-bs-toggle="collapse"]');
            var collapseParent = this.element.find(collapseElement.data('parent'));
            if (collapseElement.length > 0) {
                var checkbox = collapseElement.find('input[type="checkbox"]');
                if (checkbox.length > 0) {
                    var disableValidationElement = collapseElement.find('.disable-validation');
                    disableValidationElement.data('disable-validation', disableValidationElement.val());

                    if (checkbox.prop('checked')) {
                        if (collapseParent) {
                            const collapseParentObj = Collapse.getOrCreateInstance(collapseParent, {
                                container: 'body'
                            });
                            collapseParentObj.show();
                        }

                        disableValidationElement.val('');
                    }

                    collapseParent.on('show.bs.collapse', function () {
                        setTimeout(function(){
                            checkbox.prop('checked', true);
                            disableValidationElement.val('');
                        }, 50);
                    });
                    collapseParent.on('hide.bs.collapse', function () {
                        setTimeout(function() {
                            checkbox.prop('checked', false);
                            disableValidationElement.val(disableValidationElement.data('disable-validation'));
                        });
                    });
                }
            }
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            } else {
                $.data(this, 'plugin_' + pluginName).init();
            }
        });
    };
})(jQuery);
